export default "__VITE_ASSET__BZhwURD6__"